// context/TenantContext.js
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { getTenantContext, switchTenant } from "../library/allauth";

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const [activeCustomerId, setActiveCustomerId] = useState(null);
  const [activeSchema, setActiveSchema] = useState(null);
  const [available, setAvailable] = useState([]);
  const [mustSelect, setMustSelect] = useState(false);
  const [isMulti, setIsMulti] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getTenantContext();
      const d = res?.data || {};
      setActiveCustomerId(d.active_customer_id ?? null);
      setActiveSchema(d.active_schema ?? null);
      setAvailable(d.available || []);
      setMustSelect(!!d.must_select);
      setIsMulti(!!d.is_multi);
    } catch (e) {
      setAvailable([]);
      setMustSelect(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const selectTenant = useCallback(
    async (customerId) => {
      await switchTenant(customerId);
      await refresh();
    },
    [refresh]
  );

  return (
    <TenantContext.Provider
      value={{
        activeCustomerId,
        activeSchema,
        available,
        mustSelect,
        isMulti,
        loading,
        refresh,
        selectTenant,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};
